import { ACCOUNT_CATEGORIES } from 'Components/pages/AccountPage/AccountPage.consts';
import { VEHICLE_LIST_FILTER_NAME } from 'Components/VehicleList/VehicleListFilters.consts';
import { isAccountPageNotFound } from 'Server/helpers';
import { AccountCategory, AccountSlugs } from 'Types/account';
import { LIST_TYPES } from 'Utilities/consts';
import ROUTES from 'Utilities/routes';

import type { GetInitialPropsMiddleware } from '../getInitialPropsMiddlewares.types';

const shortlistRedirectUrl = `${ROUTES.VEHICLE_LIST.as()}?${VEHICLE_LIST_FILTER_NAME.LIST_TYPE}=${
	LIST_TYPES.shortlist
}`;

export const accountRouteHandler: GetInitialPropsMiddleware = async (context, next) => {
	const { nextContext } = context;
	const { isSSR } = nextContext;

	if (isSSR) {
		const {
			query: { params },
			res,
		} = nextContext;

		const [category, slug] = params || [];

		if (category === ACCOUNT_CATEGORIES.SHORTLIST) {
			res?.redirect(301, shortlistRedirectUrl);

			return;
		}

		const hasNoParams = !params?.length;
		const isMoreThanTwoParams = params?.length && params.length > 2;
		const isIncorrectParams = isAccountPageNotFound({ query: { category, slug } });

		if (hasNoParams) {
			res?.redirect(301, ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.ACTIVE));

			return;
		}

		if (params?.length === 1) {
			if (category === AccountCategory.PURCHASES) {
				res?.redirect(301, ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.COMPLETE));

				return;
			}

			if (category === AccountCategory.BIDS) {
				res?.redirect(301, ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.ACTIVE));

				return;
			}
		}

		if (isMoreThanTwoParams || isIncorrectParams) {
			res?.redirect(301, ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.COMPLETE));

			return;
		}
	}

	await next();
};
